import wire from '../wire';
import { storage } from '../../auth/utils';

let module = wire(
  'home',
  '',
  () => {
    // check for homepage version redirect to vue /home or /dashboard
    const homeKey = storage.get('new-home');
    const url = homeKey === '0' ? 'home' : 'broadcasts';

    window.location.replace(`${window.VUE_DASHBOARD_ROOT}/${url}`);
  },
  'HomeController',
  '/'
);
export default module;



// WEBPACK FOOTER //
// ./app/pages/home/_index.js